import { render, staticRenderFns } from "./vip-simulation.vue?vue&type=template&id=2b347f3f&scoped=true&"
import script from "./vip-simulation.vue?vue&type=script&lang=js&"
export * from "./vip-simulation.vue?vue&type=script&lang=js&"
import style0 from "./vip-simulation.vue?vue&type=style&index=0&id=2b347f3f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b347f3f",
  null
  
)

export default component.exports